import React from "react";
import moment from "moment";
import "./BriefDays.scss";

const BriefDays = ({ dates }: { dates: { date: string }[] }) => (
  <div className="brief-days">{dates?.map(({ date }) => moment(date).format("DD MMM, YYYY")).join("; ")}</div>
);

export default BriefDays;
